import userCreate from "@/api/requests/userCreate";
import { date } from "@/plugins/date";
import User from "@/types/User";
import { Ref, ref } from "vue";

type UserRegisterModel = Omit<User, "id" | "status" | "email_verified_at" | "integration_tiers">;

export function useRegisterForm() {
  const model: Ref<UserRegisterModel> = ref({
    name: "",
    document: "",
    document_type: "cpf" as const,
    email: "",
    cellphone: "",
    birth_date: "",
    address: {
      street: "",
      number: "",
      neighborhood: "",
      complement: "",
      city: "",
      state: "",
      zipcode: "",
      country: "Brazil",
    },
    password: "",
    username: "",
    gender_id: 1,
  });

  async function submit(): Promise<User> {
    model.value.username = model.value.name.replace(/[\W_]+/g, "").toLowerCase();

    model.value.birth_date = date.format(model.value.birth_date, "y-MM-dd", "dd/MM/y");

    // Casting the model value as User to match the expected parameter type
    const result = await userCreate(model.value as User);

    return result;
  }

  return {
    model,
    submit,
  };
}
